import { Alert } from '@mui/material';

import { CheckCircleIcon } from '@libs/shared/ui/icons';

type Props = {
  text: string;
};

export const AlertSuccess = ({ text }: Readonly<Props>) => (
  <Alert severity="success" icon={<CheckCircleIcon />}>
    {text}
  </Alert>
);
